var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSideArrow = function SvgSideArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 6,
    height: 10,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#5E5F61",
    d: "M4.04 4.588c.252.2.256.53.006.734L0 8.587V10h.006l5.808-4.689c.25-.201.248-.534-.006-.733L0 0v1.402z"
  })));
};
export { SvgSideArrow as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNiIgaGVpZ2h0PSIxMCIgdmlld0JveD0iMCAwIDYgMTAiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxwYXRoIGQ9Ik00LjAzOTk1IDQuNTg3OTJDNC4yOTIxOCA0Ljc4NzU1IDQuMjk2MzUgNS4xMTg1NSA0LjA0NjIgNS4zMjE1OUwwIDguNTg3MjRMMCA5Ljk5OTk3SDAuMDA2MjUzNzlMNS44MTM5NCA1LjMxMTM1QzYuMDY0MDkgNS4xMTAwMiA2LjA2MiA0Ljc3NzMxIDUuODA3NjggNC41Nzc2OUwwIC0zLjA1MTc2ZS0wNUwwIDEuNDAyNDZMNC4wMzk5NSA0LjU4NzkyWiIgZmlsbD0iIzVFNUY2MSIvPgo8L3N2Zz4K";